import { BaseClient } from '@/api'

export class StationAdminClient extends BaseClient {
  constructor(
  ) {
    super('station-admins')
  }
}
